import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const AddDriverModal = ({
  isOpen,
  toggle,
  formData,
  handleInputChange,
  handleSubmit,
  loading,
  errors,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add Driver</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="name">Full Name</Label>
            <Input
              type="text"
              name="name"
              id="name"
              required
              autoComplete="off"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="name">Email</Label>
            <Input
              type="email"
              name="email"
              id="email"
              autoComplete="off"
              required
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="password">Password</Label>
            <InputGroup>
              <Input
                type={showPassword ? "text" : "password"}
                name="password"
                autoComplete="off"
                required
                id="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
              />
              <InputGroupText
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </InputGroupText>
            </InputGroup>
            <p
              style={{
                fontSize: "12px",
                color: "red",
                marginTop: "5px",
              }}
            >
              {errors}
            </p>
          </FormGroup>

          <div className="d-flex justify-content-end">
            <Button color="primary" disabled={loading} type="submit">
              {loading ? <Spinner size="sm" /> : "Save"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AddDriverModal;
